// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/DollarCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var DollarCircleTwoTone = function DollarCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleTwoToneSvg
  }));
};

DollarCircleTwoTone.displayName = 'DollarCircleTwoTone';
export default React.forwardRef(DollarCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DollarCircleTwoTone.js
// module id = 959
// module chunks = 0